export const lemaTheme = {
    mainColor: 'rgba(12,32,67,1)',
    secondaryColor: 'rgba(12,32,67,0.7)',
}